import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconFile.module.css';

const PNG = 'PNG';
const DICOM = 'DICOM';
const DCM = 'DCM';
const PDF = 'PDF';
const WORD = 'DOC';
const WORDX = 'DOCX';
const EXCEL = 'XLS';
const EXCELX = 'XLSX';
const JPG = 'JPG';
const GIF = 'GIF';
const JPEG = 'JPEG';

const SMALL = 'small';
const LARGE = 'large';

const IconFile = props => {
  const { rootClassName, className, pencilClassName, type, size = 'small' } = props;
  const classes = classNames(rootClassName || css.root, className);

  const renderIcon = () => {
    switch (type) {
      case PNG:
      case DICOM:
      case JPG:
      case GIF:
      case JPEG:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 10.5C14.695 10.5 15.13 10.368 15.5 10.1208C15.87 9.87357 16.1584 9.52217 16.3287 9.11104C16.499 8.69991 16.5436 8.24751 16.4568 7.81105C16.37 7.37459 16.1557 6.97368 15.841 6.65901C15.5263 6.34434 15.1254 6.13005 14.689 6.04323C14.2525 5.95642 13.8001 6.00097 13.389 6.17127C12.9778 6.34157 12.6264 6.62996 12.3792 6.99997C12.132 7.36998 12 7.80499 12 8.25C12 8.84674 12.2371 9.41903 12.659 9.84099C13.081 10.2629 13.6533 10.5 14.25 10.5ZM14.25 7.5C14.3983 7.5 14.5433 7.54399 14.6667 7.6264C14.79 7.70881 14.8861 7.82594 14.9429 7.96299C14.9997 8.10003 15.0145 8.25083 14.9856 8.39632C14.9567 8.5418 14.8852 8.67544 14.7803 8.78033C14.6754 8.88522 14.5418 8.95665 14.3963 8.98559C14.2508 9.01453 14.1 8.99968 13.963 8.94291C13.8259 8.88615 13.7088 8.79002 13.6264 8.66668C13.544 8.54334 13.5 8.39834 13.5 8.25C13.5 8.05109 13.579 7.86032 13.7197 7.71967C13.8603 7.57902 14.0511 7.5 14.25 7.5Z"
              fill="black"
            />
            <path
              d="M19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM19.5 19.5H4.5V15L8.25 11.25L12.4425 15.4425C12.7235 15.7219 13.1037 15.8787 13.5 15.8787C13.8963 15.8787 14.2765 15.7219 14.5575 15.4425L15.75 14.25L19.5 18V19.5ZM19.5 15.8775L16.8075 13.185C16.5265 12.9056 16.1463 12.7488 15.75 12.7488C15.3537 12.7488 14.9735 12.9056 14.6925 13.185L13.5 14.3775L9.3075 10.185C9.02646 9.90562 8.64628 9.74881 8.25 9.74881C7.85372 9.74881 7.47354 9.90562 7.1925 10.185L4.5 12.8775V4.5H19.5V15.8775Z"
              fill="black"
            />
          </svg>
        );
      case PDF:
      case DCM:
      case WORD:
      case WORDX:
      case EXCEL:
      case EXCELX:
        return size === SMALL ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 21C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7Z"
              stroke="#4A4A4A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="#FFFFFF"
            />
            <path
              d="M13 3V9H19"
              stroke="#4A4A4A"
              strokeWidth="2"
              strokeLinejoin="round"
              fill="#FFFFFF"
            />
          </svg>
        ) : (
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 52.5C16.1739 52.5 14.9021 51.9732 13.9645 51.0355C13.0268 50.0979 12.5 48.8261 12.5 47.5V7.5H35L47.5 20V47.5C47.5 48.8261 46.9732 50.0979 46.0355 51.0355C45.0979 51.9732 43.8261 52.5 42.5 52.5H17.5Z"
              stroke="#4A4A4A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="#FFFFFF"
            />
            <path
              d="M32.5 7.5V22.5H47.5"
              stroke="#4A4A4A"
              strokeWidth="2"
              strokeLinejoin="round"
              fill="#FFFFFF"
            />
          </svg>
        );
      default: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 21C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7Z"
              stroke="#4A4A4A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="#FFFFFF"
            />
            <path
              d="M13 3V9H19"
              stroke="#4A4A4A"
              strokeWidth="2"
              strokeLinejoin="round"
              fill="#FFFFFF"
            />
          </svg>
        );
      }
    }
  };

  const icon = renderIcon();

  return <>{icon}</>;
};

IconFile.defaultProps = {
  rootClassName: null,
  className: null,
  pencilClassName: null,
  type: null,
};

const { string } = PropTypes;

IconFile.propTypes = {
  rootClassName: string,
  className: string,
  pencilClassName: string,
  type: string,
};

export default IconFile;
